import { TPagination } from 'src/@types';
import { IFilter } from 'src/@types/apiResponse';
import { IHospitalInfo } from 'src/models';
import { HospitalFormData } from 'src/screens/hospital-management/components/AddHospitalForm';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

const SUB_URL = '/hospital';

/** 병원 정보 조회 (회원가입) */
export const getHospitalInfo = async () => {
  try {
    const url = `${SUB_URL}/info`;

    const response = await instance.get<TApiResponseData<IHospitalInfo[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 병원 목록 조회 */
export const getHospitals = async (pagination: TPagination, filterCondition: IFilter) => {
  try {
    let url = `${SUB_URL}?page=${pagination.page}&size=${pagination.size}`;
    if (filterCondition.filter) {
      url += `&${filterCondition.filter}=${filterCondition.keyword}`;
    }

    const response = await instance.get<TApiResponseData<IHospitalInfo[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 병원 등록 */
export const setHospital = async (formData: HospitalFormData) => {
  try {
    const url = `${SUB_URL}`;

    const response = await instance.post<TApiResponseData<IHospitalInfo>>(url, formData);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 병원 상세 조회 */
export const getHospital = async (hsptlSid: number) => {
  try {
    const url = `${SUB_URL}/${hsptlSid}`;

    const response = await instance.get<TApiResponseData<IHospitalInfo>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 병원 정보 수정 */
export const updateHospital = async (hospital: IHospitalInfo) => {
  try {
    const url = `${SUB_URL}/${hospital.hsptlSid}`;

    const response = await instance.put<TApiResponseData<IHospitalInfo>>(url, hospital);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/** 병원 삭제 */
export const deleteHospital = async (hsptlSid: number) => {
  try {
    const url = `${SUB_URL}/${hsptlSid}`;

    const response = await instance.delete<TApiResponseData<any>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
